/**
 * Created by rathompson on 8/18/23
 * File: ReadOnlyButton.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import type { ButtonProps } from '@panwds/react-ui'
import useReadOnly from '../../hooks/useReadOnly'
import TooltipButton from '../tooltipButton/TooltipButton'
import { TOOLTIP_READ_ONLY } from '../../../iam/constants/LabelConstants'
import { Button } from '@panwds/react-ui'

const ReadOnlyButton: VFC<ButtonProps & {
  tsg_id: string,
  permissionSet: string
}> = ({ tsg_id, permissionSet, children, ...rest }) => {

  const readOnly = useReadOnly(tsg_id, permissionSet)

  if (readOnly) {
    return (
      <TooltipButton
        label={TOOLTIP_READ_ONLY}
        disabled
        buttonProps={{
          ...rest,
        }}
      >{children}</TooltipButton>
    )
  }
  return (
    <Button {...rest}>{children}</Button>
  )
}

export default ReadOnlyButton
